import { useState } from "react";
import { useNavigate } from "react-router";
import { Button } from "@/components/ui/FormControls";
import { hasFeature, type LicensedFeature } from "@/lib/license";
import { useAuth } from "@/store/auth";

export function LicensedAction({ label, title, description, feature, onAvailable }: {
  label: string;
  title: string;
  description: string;
  feature: LicensedFeature;
  onAvailable?: () => void;
}) {
  const nav = useNavigate();
  const userLicense = useAuth((state) => state.user?.license);
  const [open, setOpen] = useState(false);
  const available = hasFeature(feature, userLicense);

  function handleClick() {
    if (available) {
      onAvailable?.();
      if (!onAvailable) nav("/workspace");
      return;
    }
    setOpen((value) => !value);
  }

  return (
    <div className="licensed-action">
      <Button variant="secondary" onClick={handleClick} aria-expanded={!available && open}>
        {label}
      </Button>
      {!available && open && (
        <div className="licensed-inline-lock" role="status">
          <div className="licensed-inline-lock-copy">
            <strong>{title}</strong>
            <span>이 기능은 기업용 라이선스에서 사용할 수 있습니다.</span>
            <small>{description}</small>
          </div>
          <Button type="button" size="compact" onClick={() => setOpen(false)}>닫기</Button>
        </div>
      )}
    </div>
  );
}
